export default "__VITE_ASSET__D8IMh3lF__"